function OnRun() {
  'ngInject';
}

export default OnRun;
